"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.Y_AXIS = exports.X_AXIS = void 0;
var X_AXIS;
(function (X_AXIS) {
    X_AXIS["outsideLeft"] = "outside-left";
    X_AXIS["outsideRight"] = "outside-right";
    X_AXIS["insideLeft"] = "inside-left";
    X_AXIS["insideRight"] = "inside-right";
    X_AXIS["middle"] = "middle";
})(X_AXIS = exports.X_AXIS || (exports.X_AXIS = {}));
var Y_AXIS;
(function (Y_AXIS) {
    Y_AXIS["outsideTop"] = "outside-top";
    Y_AXIS["outsideBottom"] = "outside-bottom";
    Y_AXIS["insideTop"] = "inside-top";
    Y_AXIS["insideBottom"] = "inside-bottom";
    Y_AXIS["middle"] = "middle";
})(Y_AXIS = exports.Y_AXIS || (exports.Y_AXIS = {}));
//# sourceMappingURL=types.js.map